import { render } from "./probaworkflows_sidebar.html?vue&type=template&id=4f0f9395&external"
import script from "./probaworkflows_sidebar.js?vue&type=script&lang=js&external"
export * from "./probaworkflows_sidebar.js?vue&type=script&lang=js&external"

import "./ProbaWorkflowsSidebar.vue?vue&type=style&index=0&id=4f0f9395&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__